import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useFeaturesWithDefaults } from '../../hooks/features/useFeatures';
import { transformFeatureRecordWithDefaults } from './translatedFeatureUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const removeBreaks = content => {
  const formattedSections = [];
  if (!content) {
    return formattedSections;
  }
  const sections = content.split(/<br\/>|<br \/>/);
  sections.forEach((section, index) => {
    formattedSections.push( /*#__PURE__*/_jsx(SanitizedText, {
      body: section,
      formattingOptions: {
        isPlainText: false,
        shouldPreserveNewlines: true,
        shouldOpenLinksInNewTab: true
      }
    }, index));
  });
  return formattedSections;
};
const TranslatedFeature = ({
  translated,
  attribute,
  productLevel
}) => {
  const shortName = translated.shortName.trim();
  const {
    features
  } = useFeaturesWithDefaults();
  const feature = features[shortName];
  const translatedDefaults = feature ? transformFeatureRecordWithDefaults({
    feature,
    productLevel
  }) : null;
  const translation = translated[attribute] || translatedDefaults && translatedDefaults[attribute];
  if (translation) {
    if (attribute === 'name') return /*#__PURE__*/_jsx(_Fragment, {
      children: translation
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: removeBreaks(translation)
    });
  }
  return null;
};
export default TranslatedFeature;